const jsonwebtoken = require('jsonwebtoken');

const jwt_encode = (indata,
    privateKey,
    refreshable = false,
    expiresIn = 157788000) => {

    indata.refreshable = refreshable;

    try {
        const token = jsonwebtoken.sign(indata,
            privateKey,
            { algorithm: 'RS256', expiresIn }
        )
        return token

    } catch (e) {
        throw {
            "error": {
                "errorCode": 401,
                "errorText": e
            }
        }
    }
}

const jwt_decode = (token, publicKey) => {
    try {
        let origData = jsonwebtoken.verify(token, publicKey, { algorithms: ['RS256'] })
        return origData;
    } catch (e) {
        throw {
            "error": {
                "errorCode": 401,
                "errorText": e
            }
        }
    }
}

module.exports = {
    jwt_encode,
    jwt_decode
}
